import React, { useState } from "react";
import { LuPlus } from "react-icons/lu";
import { useLocation, useNavigate } from "react-router-dom";
import VendorLayout from "./VendorLayout";
import UserManagementUsers from "./UserManagementUsers";
import UserManagementRolesPermissions from "./UserManagementRolesPermissions";
import "./vendorUserManagement.css";
import { translateLabel, useTranslationSnapshot } from "./../translations/runtime";


function UserManagement() {
  useTranslationSnapshot();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeSection, setActiveSection] = useState(() => {
    const query = new URLSearchParams(location.search);
    return query.get("tab") === "roles" ? "roles" : "users";
  });
  const isUsersSection = activeSection === "users";
  const isPreview = location.pathname.endsWith("-preview");
  const addUserPath = isPreview
    ? "/vendor-add-user-preview"
    : "/vendor-user-management/add";
  const addRolePath = isPreview
    ? "/vendor-add-role-preview"
    : "/vendor-user-management/roles/add";

  return (
    <VendorLayout activeKey="users">
      <div className="user-management-main-container">
        <div className="user-management-header">
          <div className="user-management-title-container">
            <div className="user-management-title">{translateLabel("txt_web_vendor_user_management", "User Management")}</div>
            <div className="user-mangement-header-text">
              {translateLabel("txt_web_vendor_user_management_description", "Manage all users in one place. Control access, assign roles, and monitor activity across your platform.")}
            </div>
          </div>

          <button
            className="user-management-new-user"
            type="button"
            onClick={() => {
              navigate(isUsersSection ? addUserPath : addRolePath);
            }}
          >
            <LuPlus aria-hidden="true" />
            {isUsersSection ? translateLabel("txt_web_vendor_new_user", "New User") : translateLabel("txt_web_vendor_new_role", "New Role")}
          </button>
        </div>

        <div
          className="management-users-roles-permissions"
          role="tablist"
          aria-label={translateLabel("txt_web_vendor_user_management_sections", "User management sections")}
        >
          <button
            className={
              isUsersSection
                ? "management-manage-users-selected"
                : "management-manage-users"
            }
            type="button"
            role="tab"
            aria-selected={isUsersSection}
            onClick={() => setActiveSection("users")}
          >
            {translateLabel("txt_web_vendor_users_tab", "Users")}
          </button>
          <button
            className={
              !isUsersSection
                ? "management-manage-users-selected"
                : "management-manage-users"
            }
            type="button"
            role="tab"
            aria-selected={!isUsersSection}
            onClick={() => setActiveSection("roles")}
          >
            {translateLabel("txt_web_vendor_roles_permissions_tab", "Roles & Permissions")}
          </button>
        </div>

        <div className="users-managening">
          {isUsersSection ? (
            <UserManagementUsers />
          ) : (
            <UserManagementRolesPermissions />
          )}
        </div>
      </div>
    </VendorLayout>
  );
}

export default UserManagement;
